import classNames from 'classnames'
import {useSelector} from 'react-redux'

const SimpleBlueButton = ({children, outline, onClick, type, disabled, className, id}) => {
    const isDarkmode = useSelector(state => state.sidebar.isDarkMode)

    return (
        <button
            type={type}
            onClick={onClick}
            id={id}
            disabled={disabled}
            className={classNames('simple-blue-button', {
                [className]: !!className,
                'outline': outline,
                'dark': isDarkmode
            })}>
            {children}
        </button>
    )
}

export default SimpleBlueButton
